import { ArgsType, Field, Int } from '@nestjs/graphql'

import { BaseUpdateDto } from '../base/baseUpdate.dto'
import { UpdateUserPreferencesDto } from './preferences'

@ArgsType()
export class UpdateUserDto extends BaseUpdateDto<UpdateUserDto> {
  @Field({ nullable: true })
  name?: string

  @Field({ nullable: true })
  image?: string

  @Field({ nullable: true })
  kindleEmail?: string

  @Field({ nullable: true })
  verifiedKindleEmail?: boolean

  @Field({ nullable: true })
  amazonProfileLink?: string

  @Field({ nullable: true })
  notificationRegistrationToken?: string

  @Field({ nullable: true })
  preferences?: UpdateUserPreferencesDto

  @Field({ nullable: true })
  skipThirdPartySync?: boolean

  // The properties below aren't exposed via the graphql interface
  @Field(t => [Int], { nullable: true })
  canActAs?: number[]

  @Field({ nullable: true })
  completedTours?: string

  @Field({ nullable: true })
  authorRole?: string

  @Field({ nullable: true })
  lastLoginDate?: Date

  // comma separated list
  @Field({ nullable: true })
  usedCouponCodes?: string
}
